import { Feriado } from '../domain/feriado.model';
import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';

export class FeriadoSerializer extends DomainSerializer<Feriado> {}
